export default {
    title: 'Предыдущие предписания',
    goToPrescription: 'Перейти к предписанию',
};
